import BaseRepository from './base.repository';
class NavigatorHomeRepository extends BaseRepository {
  constructor() {
    super('/');
  }

  getAppointments(params) {
    return this.client.get('haven/appointment/', params);
  }

  getAppointmentByManUnique(mainUnique) {
    return this.client.get(`haven/appointment/${mainUnique}`);
  }

  cancelAppointment(mainUnique, cancelReason) {
    return this.client.post(`haven/appointment/${mainUnique}/cancel`,  cancelReason );
  }

  rescheduleAppointment(mainUnique, payload) {
    return this.client.put(`haven/appointment/${mainUnique}`,  payload );
  }

  getTreatmentActive() {
    return this.client.get('savanne/treatments/active');
  }

  getPILDetailsByCode(code) {
    return this.client.get(`savanne/pil/code/${code}`);
  }

  getDailyProgress() {
    return this.client.get('haven/progress/daily');
  }

  getWeeklyProgress() {
    return this.client.get('haven/progress/weekly-insights');
  }
}

export default new NavigatorHomeRepository();
